import React from 'react'

const PreparePr = () => {
    return (
        <div>PreparePr</div>
    )
}

export default PreparePr